<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },

  render(createElement) {
    return this.$scopedSlots.default({
      isOpen: this.isOpen,
      open: () => (this.isOpen = true),
      close: () => (this.isOpen = false),
      toggle: () => (this.isOpen = !this.isOpen)
    });
  },

  created() {
    let handler = event => {
      if (!this.$el.contains(event.target) && this.isOpen) {
        this.isOpen = false;
      }
    };

    document.addEventListener("click", handler);

    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("click", handler);
    });
  }
};
</script>